module.exports = __webpack_public_path__ + "img/link_goals.70cba3d6.svg";